import React from 'react';

// Components
import Profile from './Components/Profile';

const useProfiles = (profiles, accounts) => {
    return profiles.reduce(([open, closed], profile) => {
        const account = accounts[profile.AccountId];
        if (account.IsClosed) {
            return [open, closed.concat([profile])];
        }

        return [open.concat([profile]), closed];
    }, [[], []]);
}

const ProfileList = (props) => {
    const [openedProfiles, closedProfiles] = useProfiles(props.profiles, props.accounts);

    const Wrapper = Inject({
        accounts: props.accounts,
        apps: props.apps,
        onClick: props.onClick,
        selected:props.selected,
    });

    const availableProfilesCount = countAvailableProfiles(openedProfiles) + countAvailableProfiles(closedProfiles);

    if (props.renderEmpty && availableProfilesCount === 0) {
        return props.renderEmpty();
    }

    const OpenedProfiles = Wrapper(RenderOpenedProfiles);
    const ClosedProfiles = Wrapper(RenderClosedProfiles);

    return (
        <div className="ProfileList flex flex-col gap-1">
            <OpenedProfiles profiles={openedProfiles} />
            <ClosedProfiles profiles={closedProfiles} />
        </div>
    )
}

const RenderProfiles = (props) => {
    return (
        props.profiles.map((profile, index) => {
            if (profile.unavailable) {
                return null;
            }

            const account = props.accounts[profile.AccountId];
            const title = account.Name;

            const app = props.apps[profile.AppId];
            const icon = app.Icon;

            const className = (props.selected.includes(profile.ProfileId) ? 'Profile-selected !bg-slate-100' : '');
            
            const profileOnClick = props.closed ? (e) => {
                e.preventDefault();
                e.stopPropagation();
            } : (e) => {
                e.preventDefault();
                e.stopPropagation();
                props.onClick(profile);
            };

            return (
                <a
                    href="#"
                    key={index}
                    onClick={profileOnClick}
                    className={`${props.closed ? 'closed-profile' : ''} group focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-slate-500 rounded-sm`}
                >
                    <Profile title={title} subtitle={app.Description} icon={icon} className={className} />
                </a>
            )
        })
    )
};

const RenderOpenedProfiles = (props) => {
    return <RenderProfiles {...props}></RenderProfiles>
};

const RenderClosedProfiles = (props) => {
    if (props.profiles.length === 0) {
        return null;
    }
    
    return (
        <>
            <p className="closed-profile-title">Closed Accounts</p>
            <RenderProfiles {...props} closed={true}></RenderProfiles>
        </>
    );
};

const Inject = (hocProps) => {
    return (Comp) => (props) => <Comp {...hocProps} {...props} />;
}

/**
 * @param {Array<any>} profiles 
 * 
 * @returns {number}
 */
const countAvailableProfiles = (profiles) => {
    if (!profiles || !Array.isArray(profiles)) {
        return 0;
    }

    return profiles.filter((profile) => !profile.unavailable).length;
}

ProfileList.defaultProps = {
    profiles: [],
    accounts: {},
    apps: {},
    onClick: () => {},
    selected: [],
    renderEmpty: null,
}

export default ProfileList;
